@use '../../scss/utility/functions' as utility;
@use './vertical-scroll-vars';

:host {
  @include vertical-scroll-vars.wb-vertical-scroll-vars;

  display: block;
}

.container {
  display: block;
  position: relative;
  max-height: inherit;
  transition-property: -webkit-mask-size, mask-size;
  transition-duration: 0.3s;
  transition-timing-function: var(--wb-fade);
}

.has-mask {
  -webkit-mask-image: var(--mask-image);
  -webkit-mask-size: var(--mask-size);
  -webkit-mask-position: var(--mask-position);
  mask-image: var(--mask-image);
  mask-size: var(--mask-size);
  mask-position: var(--mask-position);
}

.mask-top {
  @include vertical-scroll-vars.wb-vertical-scroll-mask-top-vars;
}

.mask-bottom {
  @include vertical-scroll-vars.wb-vertical-scroll-mask-bottom-vars;
}

.mask-full {
  @include vertical-scroll-vars.wb-vertical-scroll-mask-full-vars;
}

.inner {
  max-height: inherit;
  overflow-y: auto;
}
